document.addEventListener("DOMContentLoaded", function () {
    initNavigationMenu();
    initProductFilters();
    initCartOverlay();
    initColorSwatch();
    initAccordeon();
    initTalismanConfigurator();
});